// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hp-0";